import { userTablePreferencesApi } from './userTablePreferencesActions';

export const tableViewApis = [userTablePreferencesApi] as const;
